// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 176 ? "9faac84a" : chunkId) + "." + {"176":"c9da2841ad954ec6","758":"b3744d03329151b7","941":"7fd0fa56be3c92e5"}[chunkId] + ".js";
};